import React from "react";
import {NativeStackScreenProps} from "@react-navigation/native-stack";
import HomeView from "./HomeView";
import KnowsleyHomeView from "./KnowsleyHomeView";
import {AppStackParams} from "../../routes/AppStack";
import {navigationService} from "../../services/NavigationService";

type NavigationProps = NativeStackScreenProps<AppStackParams, 'Home'>;

const Home = ({navigation}: NavigationProps) => {

    function getViewByDomain(){
        if (navigationService.isknowsley()){
           return <KnowsleyHomeView route={{key: "Home", name: "Home"}} navigation={navigation}></KnowsleyHomeView>
        }

        return <HomeView route={{key: "Home", name: "Home"}} navigation={navigation}></HomeView>
    }

    return (
        getViewByDomain()
    );
};

export default Home;
